export const languageCodes = {
  en: "english",
  sv: "swedish",
} as const;
